import { useTheme } from 'styled-components';
import { useMemo } from 'react';
import { ThemeProvider } from '@workramp/ui';
import { getEnterprisePalette } from '../../utils';

type EnterpriseColorProviderProps = {
  children: React.ReactNode;
};

export function EnterpriseColorProvider({ children }: EnterpriseColorProviderProps) {
  const primary = getEnterprisePalette();
  const theme = useTheme();

  const themeWithColors = useMemo(
    () => ({
      ...theme,
      colors: {
        ...theme.colors,
        primary,
      },
    }),
    [primary, theme],
  );
  return <ThemeProvider theme={themeWithColors}>{children}</ThemeProvider>;
}
